export interface KeepTryingOptions {
  readonly interval: number;
  readonly giveUpAfter: number;
}

export const defaultKeepTryingOptions: KeepTryingOptions = {
  interval: 30,
  giveUpAfter: 300
};

export function keepTrying(conditionFn: () => boolean, { giveUpAfter, interval }: any = defaultKeepTryingOptions): Promise<any> {
  let passedTime = 0;
  return new Promise((resolve, reject) => {
    if (giveUpAfter < interval) reject(new Error(`keepTrying error: Check interval("${interval}" is higher then time to give up ("${giveUpAfter}")`));
    const index = setInterval(() => {
      // success

      if (conditionFn()) {
        clearInterval(index);
        return resolve(true);
      }

      // fail
      if (passedTime >= giveUpAfter) {
        clearInterval(index);
        return reject(new Error(`keepTrying gave up after "${giveUpAfter}"`));
      }

      passedTime += interval;
    }, interval);
  });
}
